const prevent = e => [e.preventDefault(), e.stopPropagation()];
export { prevent };
//# sourceMappingURL=prevent.mjs.map
